import {
  AUTH_FETCH_FIREBASE_TOKEN,
  AUTH_SET_TOKEN,
  AUTH_VALIDATE
} from '@actions/types'

export const fetchFirebaseTokenAction = ({ apiKey, hash }) => ({
  type: AUTH_FETCH_FIREBASE_TOKEN,
  payload: {
    request: {
      method: 'post',
      url: `fb/${hash}`,
      headers: { 'x-api-key': apiKey }
    }
  }
})

export const setTokenAction = ({ apiKey, hash }) => ({
  type: AUTH_SET_TOKEN,
  payload: {
    request: {
      data: {
        token: 'declined_web'
      },
      headers: { 'x-api-key': apiKey },
      method: 'post',
      url: `token/${hash}`
    },
    setLoading: {
      meta: null
    }
  }
})

export const validateAction = ({ personalAccessCode }) => ({
  type: AUTH_VALIDATE,
  payload: {
    request: {
      method: 'post',
      url: `validate/${personalAccessCode}`
    },
    setLoading: {
      meta: null
    }
  }
})
